<template>
  <BaseModal cardWidth="600px" noPadding noToolbar noExit @close="$emit('close')">
    <template #default>
      <!-- Modal Header -->
      <div class="relative w-full p-5 flex items-center border-b border-border-normal">
        <SocialsIcon class="text-icon-muted" />
        <BaseText type="label" size="sm" class="text-text-muted px-1.5">
          Socials
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal">
          {{ socials.length }}
        </BaseText>
        <!-- Close button -->
        <button class="absolute top-3 right-3 p-1" @click="$emit('close')">
          <TagRemoveIcon stroke="#5E6678" :width="16" :height="16" />
        </button>
      </div>
      <!-- Socials List -->
      <div class="w-full rounded-b-xl overflow-hidden">
        <div class="scrollable-content w-full" style="max-height: 400px;">
          <div class="w-full flex flex-col gap-3 p-3">
            <div v-for="(social, index) in socials" :key="`social-${index}-${social.network}`"
            class="social-row w-full flex-shrink-0">
              <div class="w-full flex items-center pl-2 pr-4 min-w-0">
                <div class="w-5 h-5 p-px flex items-center justify-center rounded overflow-hidden flex-shrink-0">
                  <component :is="social.icon" />
                </div>
                <BaseText type="label" size="sm" class="text-text-muted pl-3">
                  {{ social.name }}
                </BaseText>
                <BaseText v-if="social.handle" type="body" size="sm" class="flex-grow text-text-normal ml-2 truncate">
                  @{{ social.handle }}
                </BaseText>
              </div>
              <div>
                <div v-if="social.followers" class="ml-3 flex items-center gap-1">
                  <BaseText type="label" size="sm" class="text-text-muted">
                    {{ social.followers.toLocaleString() }}
                  </BaseText>
                  <BaseText type="body" size="sm" class="text-text-normal">
                    followers
                  </BaseText>
                </div>
              </div>
              <div class="px-2">
                <a :href="social.url" target="_blank"
                class="flex items-center gap-0.5 pl-1.5 py-1 rounded-md transition-colors duration-100 hover:bg-neutral-25">
                  <BaseText type="label" size="sm" class="text-text-muted">
                    Open
                  </BaseText>
                  <OpenExternalIcon class="text-icon-normal" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import SocialsIcon from '../../globals/Icons/SocialsIcon.vue'
import TagRemoveIcon from '../../globals/Icons/TagRemoveIcon.vue'
import OpenExternalIcon from '../../globals/Icons/OpenExternalIcon.vue'

export default {
  name: 'SocialsPreviewModal',
  components: {
    SocialsIcon,
    TagRemoveIcon,
    OpenExternalIcon
  },
  props: {
    socials: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.social-row {
  display: grid;
  grid-template-columns: 1fr 180px max-content;
  height: 36px;
  align-items: center;
}

.scrollable-content {
  overflow-y: auto;
}
.scrollable-content::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}
.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #DFE1E6;
  border-radius: 10px;
  border: 3px solid #ffffff;
  cursor: pointer;
}
.scrollable-content::-webkit-scrollbar-thumb:hover {
  background-color: #C1C7D0;
}
</style>